export function cleanupRefreshParam() {
  const url = new URL(window.location.href);
  url.searchParams.delete('refresh');
  window.history.replaceState({}, '', url.toString());
}
